"use strict";

var _regeneratorRuntime = require("/codebuild/output/src532132034/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _uiKit = require("@devsta/ui-kit");

var _commonReact = require("@devsta/common-react");

var _lodash = _interopRequireDefault(require("lodash.get"));

var _getValueFromGenericInput = require("@devsta/get-value-from-generic-input");

var _VideoSummaryCard = _interopRequireDefault(require("../../../common/components/VideoSummaryCard"));

var _VideoProjectCard = _interopRequireDefault(require("../../../common/components/VideoProjectCard"));

var _Filters = _interopRequireDefault(require("../../../common/components/Filters"));

require("../styles/_edit-folder.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (_isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var SMALL_BREAKPOINT = 850;

var EditFolder = /*#__PURE__*/function (_Component) {
  _inherits(EditFolder, _Component);

  var _super = _createSuper(EditFolder);

  function EditFolder(props) {
    var _this;

    _classCallCheck(this, EditFolder);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "onUpdateFilters", function (selectedFilters) {
      _this.setState({
        selectedFilters: selectedFilters
      }, _this.fetchProjects);
    });

    _defineProperty(_assertThisInitialized(_this), "fetchFolder", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var getVideoFolder, _yield$getVideoFolder, data, error;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              getVideoFolder = _this.props.getVideoFolder;
              _context.next = 3;
              return getVideoFolder();

            case 3:
              _yield$getVideoFolder = _context.sent;
              data = _yield$getVideoFolder.data;
              error = _yield$getVideoFolder.error;

              if (!(!data || !data.getVideoFolder || error)) {
                _context.next = 8;
                break;
              }

              return _context.abrupt("return", void _this.setState({
                error: true
              }));

            case 8:
              _this.setState({
                folderName: data.getVideoFolder.name
              });

            case 9:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));

    _defineProperty(_assertThisInitialized(_this), "fetchStats", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var getProjectStats, _yield$getProjectStat, data, error;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              getProjectStats = _this.props.getProjectStats;
              _context2.next = 3;
              return getProjectStats();

            case 3:
              _yield$getProjectStat = _context2.sent;
              data = _yield$getProjectStat.data;
              error = _yield$getProjectStat.error;

              if (!(!data || !data.getProjectStats || error)) {
                _context2.next = 8;
                break;
              }

              return _context2.abrupt("return", void _this.setState({
                error: true
              }));

            case 8:
              _this.setState({
                stats: data.getProjectStats
              });

            case 9:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    })));

    _defineProperty(_assertThisInitialized(_this), "fetchProjects", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
      var offset,
          postProcessor,
          getFilteredProjects,
          _this$state,
          selectedFilters,
          searchTerm,
          _yield$getFilteredPro,
          data,
          error,
          _data$getFilteredProj,
          count,
          projects,
          _args3 = arguments;

      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              offset = _args3.length > 0 && _args3[0] !== undefined ? _args3[0] : 0;
              postProcessor = _args3.length > 1 ? _args3[1] : undefined;
              getFilteredProjects = _this.props.getFilteredProjects;
              _this$state = _this.state, selectedFilters = _this$state.selectedFilters, searchTerm = _this$state.searchTerm;
              _context3.next = 6;
              return getFilteredProjects(_objectSpread({}, selectedFilters, {
                searchTerm: searchTerm,
                limit: 10,
                offset: offset
              }));

            case 6:
              _yield$getFilteredPro = _context3.sent;
              data = _yield$getFilteredPro.data;
              error = _yield$getFilteredPro.error;

              if (!(!data || error || !data.getFilteredProjects)) {
                _context3.next = 11;
                break;
              }

              return _context3.abrupt("return", void _this.setState({
                error: true
              }));

            case 11:
              _data$getFilteredProj = data.getFilteredProjects, count = _data$getFilteredProj.count, projects = _data$getFilteredProj.projects;

              _this.setState({
                count: count,
                projects: postProcessor ? postProcessor(projects) : projects
              });

            case 13:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    })));

    _defineProperty(_assertThisInitialized(_this), "loadMoreResults", function (_ref4) {
      var currentOffset = _ref4.currentOffset;
      var _this$state$projects = _this.state.projects,
          oldProjects = _this$state$projects === void 0 ? [] : _this$state$projects;
      return _this.fetchProjects(currentOffset, function (newProjects) {
        return [].concat(_toConsumableArray(oldProjects), _toConsumableArray(newProjects));
      });
    });

    _defineProperty(_assertThisInitialized(_this), "gotoProject", function (videoProjectId) {
      return function () {
        var history = _this.props.history;
        history.push("project/".concat(videoProjectId));
      };
    });

    _defineProperty(_assertThisInitialized(_this), "gotoNewVideo", function () {
      var _this$props = _this.props,
          history = _this$props.history,
          videoFolderId = _this$props.videoFolderId;
      history.push('/builder/new', {
        videoFolderId: videoFolderId
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleCreateProject", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
      var _this$props2, createVideoProject, organisationId, newProjectName, _yield$createVideoPro, data, error;

      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _this$props2 = _this.props, createVideoProject = _this$props2.createVideoProject, organisationId = _this$props2.organisationId;
              newProjectName = _this.state.newProjectName;
              _context4.next = 4;
              return createVideoProject({
                organisationId: organisationId,
                name: newProjectName
              });

            case 4:
              _yield$createVideoPro = _context4.sent;
              data = _yield$createVideoPro.data;
              error = _yield$createVideoPro.error;

              if (!(error || !data || !data.createVideoProject)) {
                _context4.next = 9;
                break;
              }

              return _context4.abrupt("return");

            case 9:
              _this.gotoProject(data.createVideoProject.videoProjectId)();

            case 10:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    })));

    _defineProperty(_assertThisInitialized(_this), "setModal", function (modal) {
      return function () {
        _this.setState({
          modal: modal
        });
      };
    });

    _defineProperty(_assertThisInitialized(_this), "closeModal", function () {
      _this.setState({
        modal: '',
        newProjectName: ''
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onChange", function (field) {
      return function (value) {
        _this.setState(_defineProperty({}, field, (0, _getValueFromGenericInput.getStringValueFromGenericInput)(value)));
      };
    });

    _defineProperty(_assertThisInitialized(_this), "onListFiltersChange", function (listFilters) {
      _this.setState({
        searchTerm: listFilters.searchTerm
      }, _this.fetchProjects);
    });

    _defineProperty(_assertThisInitialized(_this), "setPageRef", function (ref) {
      _this._pageRef = ref;
    });

    _defineProperty(_assertThisInitialized(_this), "getPageRef", function () {
      return _this._pageRef;
    });

    _this.state = {
      modal: '',
      error: false,
      selectedFilters: {},
      searchTerm: ''
    };
    return _this;
  }

  _createClass(EditFolder, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.fetchStats();
      this.fetchFolder();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          history = _this$props3.history,
          containerSize = _this$props3.containerSize;
      var _this$state2 = this.state,
          modal = _this$state2.modal,
          error = _this$state2.error,
          projects = _this$state2.projects,
          selectedFilters = _this$state2.selectedFilters,
          count = _this$state2.count,
          stats = _this$state2.stats,
          folderName = _this$state2.folderName;
      var small = containerSize.width < SMALL_BREAKPOINT;
      var statsKey = selectedFilters.USER ? 'global' : 'user';

      if (error) {
        return (/*#__PURE__*/_react.default.createElement(_commonReact.Error, null)
        );
      }

      var outputsCount = (0, _lodash.default)(stats, "".concat(statsKey, ".outputs"), 0);
      var projectsCount = (0, _lodash.default)(stats, "".concat(statsKey, ".projects"), 0);
      var assetsCount = (0, _lodash.default)(stats, "".concat(statsKey, ".assets"), 0);
      return (/*#__PURE__*/_react.default.createElement("div", {
          className: "edit-folder page",
          ref: this.setPageRef
        }, /*#__PURE__*/_react.default.createElement(_uiKit.FormModal, {
          visible: modal === 'project',
          onClose: this.closeModal,
          title: "Create New Project",
          onSave: this.handleCreateProject
        }, /*#__PURE__*/_react.default.createElement(_uiKit.Input, {
          placeholder: "Enter Project Name",
          onChange: this.onChange('newProjectName')
        })), /*#__PURE__*/_react.default.createElement(_uiKit.PageHeader, {
          title: folderName,
          subtitle: "Video Dashboard",
          subtitleLink: "/",
          history: history,
          breadCrumbs: [{
            title: 'Manage Projects',
            url: '/projects'
          }],
          actionBtnText: "Create New Video",
          actionBtnOnClick: this.gotoNewVideo
        }), /*#__PURE__*/_react.default.createElement("div", {
          className: "page__content"
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: "edit-folder__summary"
        }, /*#__PURE__*/_react.default.createElement("h4", null, "Manage and sort your projects"), /*#__PURE__*/_react.default.createElement("div", {
          className: "edit-folder__summary__cards"
        }, /*#__PURE__*/_react.default.createElement(_VideoSummaryCard.default, {
          count: projectsCount,
          label: "PROJECT".concat(!projectsCount || projectsCount > 1 ? 'S' : ''),
          status: "EDITING",
          small: small
        }), /*#__PURE__*/_react.default.createElement(_VideoSummaryCard.default, {
          count: outputsCount,
          label: "VIDEO".concat(!outputsCount || outputsCount > 1 ? 'S' : ''),
          status: "EDITING",
          small: small
        }), /*#__PURE__*/_react.default.createElement(_VideoSummaryCard.default, {
          count: assetsCount,
          label: "ASSET".concat(!assetsCount || assetsCount > 1 ? 'S' : ''),
          status: "EDITING",
          small: small
        }))), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
          className: "edit-folder__projects"
        }, /*#__PURE__*/_react.default.createElement(_Filters.default, {
          containerSize: containerSize,
          numResults: count,
          onUpdateFilters: this.onUpdateFilters,
          stats: {
            global: {
              total: (0, _lodash.default)(stats, 'global.projects', 0)
            }
          },
          filters: {
            USER: [{
              label: 'Created by Me',
              value: 'ME',
              selectedDefault: true
            }, {
              label: 'Created by Everyone',
              value: 'ALL'
            }]
          },
          resourceType: "project"
        }), /*#__PURE__*/_react.default.createElement(_uiKit.List, {
          onFiltersChange: this.onListFiltersChange,
          history: history,
          loading: !projects,
          data: projects,
          renderCardItem: (0, _VideoProjectCard.default)(this.gotoProject, true),
          listKey: "videoProjectId",
          filtersRightAddon: /*#__PURE__*/_react.default.createElement(_uiKit.Button, {
            type: "SECONDARY",
            onClick: this.setModal('project'),
            small: true
          }, "CREATE PROJECT"),
          loadMoreResults: this.loadMoreResults,
          totalResults: count || 0,
          getInfiniteScrollParent: this.getPageRef,
          emptyDataText: "There aren't any videos that match your filters."
        })))))
      );
    }
  }]);

  return EditFolder;
}(_react.Component);

var _default = EditFolder;
exports.default = _default;